import { css } from 'styled-components'

const extendStylesDropdownTeller = css`
    width: 177px;
`

export {
    extendStylesDropdownTeller
}